import { CHANGE_FONT_SIZE } from './types';

// action creator
export const changeFontSize = fontSize => ({
    type: CHANGE_FONT_SIZE, 
    fontSize,
});